import { AspectRatioContainer, Container, CTA, Image, ThemeProvider } from '@volkswagen-onehub/components-core';
import { globalColorsNBD, mainThemeColorsNBD } from '@volkswagen-onehub/tokens';
import * as React from 'react';
import styled from 'styled-components';
import { BenefitsCombined } from '../benefits';
import { BenefitsDescription } from './benefits-description';
import { IMAGE_DEFAULT_VWLOGO } from '../../../vw-logo';

const BenefitsCardContainer = styled.div<{ bgColor: string }>`
	height: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	backdrop-filter: blur(10px);
	border-radius: 16px;
	background: ${({ bgColor }) => bgColor};

	/* Shadow04 */
	box-shadow: none;
`;

export const VideoStyled = styled.video`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 16px;
`;

export const DescriptionCtaContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: var(--size-dynamic0100);
	gap: var(--size-dynamic0100);
`;

export const BenefitsCard: React.FC<{
	benefit: BenefitsCombined;
	handleClickBenefit: (benefit: BenefitsCombined) => void;
	primary?: boolean;
}> = ({ benefit, handleClickBenefit, primary }) => {
	const benefitCard = benefit.type === 'promotion' ? benefit.data.creativity?.card : benefit.data.card;

	const videoUrl = benefit.type === 'promotion' ? benefit.data.creativity?.card.videoUrl : undefined;

	const [isVideoReady, setIsVideoReady] = React.useState(false);

	const isInvertedTheme =
		benefit.type === 'promotion'
			? (benefit.data.status === 'OPEN' && !benefit.data.contestant?.status) ||
				benefit.data.contestant?.status === 'WINNER'
			: benefit.data.isDestacado;

	const backgroundColor = isInvertedTheme ? globalColorsNBD.digitalCobalt[100] : mainThemeColorsNBD.background.tertiary;

	return (
		<ThemeProvider theme={isInvertedTheme ? 'inverted' : 'main'}>
			<BenefitsCardContainer className="benefits-card-container" bgColor={backgroundColor}>
				<AspectRatioContainer ratio="3:2">
					{videoUrl && (
						<VideoStyled
							src={videoUrl}
							autoPlay
							playsInline
							muted
							loop
							onLoadedData={() => setIsVideoReady(true)}
							style={{ display: isVideoReady ? 'block' : 'none' }}
						/>
					)}
					{!isVideoReady && (
						<Image
							src={benefitCard?.imageUrl || IMAGE_DEFAULT_VWLOGO}
							objectFit="cover"
							alt="Benefits_image"
							style={{
								borderTopLeftRadius: '16px',
								borderTopRightRadius: '16px',
								borderBottomLeftRadius: '16px',
								borderBottomRightRadius: '16px',
							}}
						/>
					)}
				</AspectRatioContainer>

				<DescriptionCtaContainer>
					<BenefitsDescription benefit={benefit} isPrimary={primary} />

					<Container horizontalAlign="flex-start">
						<CTA
							tag="button"
							aria-label="CTA vouchers redirect"
							emphasis="primary"
							onClick={() => handleClickBenefit(benefit)}
						>
							{benefitCard?.cta?.label ?? 'Descubre más'}
						</CTA>
					</Container>
				</DescriptionCtaContainer>
			</BenefitsCardContainer>
		</ThemeProvider>
	);
};
